/*
 * @Author: Teemo Ding
 * @Date: 2021-04-15 14:49:44
 * @LastEditTime: 2023-03-29 09:38:30
 * @LastEditors: Json Chen
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/Carousel/index.tsx
 */

import { Checkbox } from '@/src/components/Antd';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
//import { EnumLinkType } from '@/src/types/common/linkType';
import React from 'react';
import { useDispatch } from 'react-redux';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
//import { randomNumber } from 'src/tools/helper';
import CarouselComponent from '../../../Components/CarouselWithChebox';
import css from './style.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { contentCarouselGenerator } from 'src/pages/SalesChannelProductsConfig';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCarousel,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  onChangeSameAsOriginal,
  onCollapseOpen,
  onDynamicDataAdd,
  onDynamicDataChange,
  onDynamicDataDelete,
  onDynamicDataSort,
  onErrorChange,
  onStaticChange,
} from '../slice';
import { validateCarousel } from '../tools';
const Carousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, specificError = {}, disabled, hideEdit } = props;
  const { sameAsOriginal } = data || {};
  const _d = useDispatch();
  const handleOnStaticChange = (draggableId, data) => {
    _d(onStaticChange({ draggableId, data }));
  };

  const handleOnAdd = (draggableId) => {
    _d(onDynamicDataAdd(contentCarouselGenerator(draggableId)));
  };

  const handleItemChange = (draggableId, index, data) => {
    _d(
      onDynamicDataChange({
        draggableId,
        index,
        data,
      }),
    );
  };

  const handleItemSort = (draggableId, from, to) => {
    _d(
      onDynamicDataSort({
        draggableId,
        from,
        to,
      }),
    );
  };

  const handleItemDelete = (draggableId, index) => {
    _d(
      onDynamicDataDelete({
        draggableId,
        index,
      }),
    );
  };

  const handleOnCustomChange = (draggableId, checked) => {
    _d(onChangeSameAsOriginal({ draggableId, sameAsOriginal: checked }));
  };

  return (
    <div>
      <Section bottomBorder>
        <div className={css.enabledContainer}>
          <Checkbox
            checked={sameAsOriginal}
            disabled={disabled}
            onChange={(checked) => handleOnCustomChange('carousel', checked)}>
            {getI18n('salesChannelProductAlias.editPage.sameasoriginal')}
          </Checkbox>
        </div>
      </Section>

      {!sameAsOriginal && (
        <CarouselComponent
          draggableId='carousel'
          onItemDelete={handleItemDelete}
          onItemAdd={handleOnAdd}
          onItemChange={handleItemChange}
          onItemSort={handleItemSort}
          onStaticChange={handleOnStaticChange}
          data={data}
          specificError={specificError}
          disabled={disabled}
          hideEdit={hideEdit}
        />
      )}
    </div>
  );
};

export default ErrorProcessingHOC(Carousel, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.carousel,
  getContent: getCarousel,
  title: getI18nFromGeneral('general.hOCTitle.carousel'),
  validation: validateCarousel,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
